export default __webpack_public_path__ + "static/media/java-developer.514908eb.png";